export default __webpack_public_path__ + "static/media/412.a93289b4.png";